import { Map, fromJS } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

const requestFailure = (dispatch, type, data, reportType) => {
  putError(dispatch, data);
  dispatch({ type });
  markStoreLoaded(dispatch, reportType);
  return true;
};

const requestSuccess = (dispatch, type, data, reportType) => {
  dispatch({ type, data });
  markStoreLoaded(dispatch, reportType);
  return true;
};

export const paymentsReportReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'PAYMENTS_DUE_REPORT_LOADED':
      return state.set('due', fromJS(action.data));
    case 'PAYMENTS_REPAY_REPORT_LOADED':
      return state.set('repay', fromJS(action.data));
    case 'PAYMENTS_OUTSTANDING_REPORT_LOADED':
      return state.set(action.isDebit ? 'outstandingDebit' : 'outstandingCredit',
        fromJS(action.data));
    case 'PAYMENTS_REPORT_CLEAR':
      return new Map();
    default:
      return state;
  }
};

export const generateDueReport = (dispatch) => {
  dispatch({ type: 'LOADING_PAYMENTS_DUE_REPORT' });
  markStoreLoading(dispatch, 'due_payments');
  return RestAPI.get('/api/report/duePayments')
    .then(
      (data) => requestSuccess(dispatch, 'PAYMENTS_DUE_REPORT_LOADED', data, 'due_payments')
    ).catch(
      (data) => requestFailure(dispatch, 'PAYMENTS_DUE_REPORT_LOADED', data, 'due_payments')
    );
};

export const generateRepayReport = (dispatch) => {
  dispatch({ type: 'LOADING_PAYMENTS_REPAY_REPORT' });
  markStoreLoading(dispatch, 'due_payments');
  return RestAPI.get('/api/report/bankRepayPayments')
    .then(
      (data) => requestSuccess(dispatch, 'PAYMENTS_REPAY_REPORT_LOADED', data, 'due_payments')
    ).catch(
      (data) => requestFailure(dispatch, 'PAYMENTS_REPAY_REPORT_LOADED', data, 'due_payments')
    );
};

export const generateOutstandingReport = (dispatch, isDebit = false) => {
  dispatch({ type: 'LOADING_PAYMENTS_OUTSTANDING_REPORT' });
  const type = `payments_outstanding_debit_${isDebit}`;
  markStoreLoading(dispatch, type);
  return RestAPI.get(`/api/report/outstandingPayments?isDebit=${isDebit}`)
    .then(
      (data) => {
        dispatch({ type: 'PAYMENTS_OUTSTANDING_REPORT_LOADED', data, isDebit });
        markStoreLoaded(dispatch, type);
        return true;
      },
    ).catch(
      (data) => requestFailure(dispatch, 'PAYMENTS_OUTSTANDING_REPORT_LOADING_FAILED',
        data, type)
    );
};

export const clearReport = dispatch => dispatch({ type: 'PAYMENTS_REPORT_CLEAR' });
